import { Component, Input, OnInit, OnChanges, Output, EventEmitter } from '@angular/core';
import { getProperty, getParseDate } from '@core/_utils/tools.utils';
import { dateFormat } from '@core/_utils/date.utils';
import { MessagesService } from '@core/_services/messages.service';
import { pdfNote, pdfColor } from '@documalis/_const/const';
import { ParseService } from '@service/parse.service';
import { FormatRequestTools } from '@service/formatrequest.tools';
import { TranslateService } from '@ngx-translate/core';
import { ApiV6Service } from '@service/apiv6.service';
import { lastValueFrom } from 'rxjs';

@Component({
    selector: 'actionsdoc',
    templateUrl: 'actionsdoc.component.html',
    styleUrls: ['actionsdoc.component.scss'],
})
export class ActionsDocComponent implements OnInit, OnChanges {
    @Input() public action;
    @Input() public position;
    @Input() public dimension;
    @Input() public numPage;
    @Input() public docInfos;
    @Input() public stamp;
    @Input() public userInfos;
    @Input() public bskMode;

    @Input()
    @Output()
    public visible: boolean;
    @Output()
    public onClose: EventEmitter<any> = new EventEmitter();
    @Output()
    public onRefresh: EventEmitter<any> = new EventEmitter();

    public fr: any;
    public error = false;
    public currentDoc;
    public currentDocId;
    public stampValue;
    public titleNote;
    public noteSelect;
    public listNote;
    public listColor;
    public colorSelect;
    public motiv;
    public password;
    public textNote;
    public textPdfValue;
    public currentColor;
    public errorMessage = '';

    constructor(
        protected _messageService: MessagesService,
        private parseService: ParseService,
        private formatRequestTools: FormatRequestTools,
        private translate: TranslateService,
        private api: ApiV6Service
    ) {
        this.listNote = new Array();
        this.listNote = pdfNote;
        this.listColor = new Array();
        this.listColor = pdfColor;
    }

    public ngOnInit() {
    }

    public ngOnChanges() {}

    public initialize() {
        this.currentDocId = getProperty(this.docInfos, 'Docid');
        this.currentDoc = getProperty(this.docInfos, 'Name') + getProperty(this.docInfos, 'Extension');
        this.stampValue = '';
        this.noteSelect = 'Comment';
        this.titleNote = '';
        this.colorSelect = 'Black';
        this.motiv = '';
        this.password = '';
        this.textNote = '';
        this.textPdfValue = '';

        if (this.action === 'stamp') {
            if (this.bskMode === true) {
                if (this.stamp.Variable === 'Ask') {
                    this.stampValue = this.stamp.Text;
                } else {
                    this.stampValue = this.stamp.Text + ' ' + this.getParsedValue(this.stamp.Variable);
                }
            }
        }
    }

    private getParsedValue(value) {
        let wformat;
        if (value) {
            wformat = getParseDate(value);
            if (wformat) {
                return dateFormat(null, wformat.useValue);
            } else {
                return this.parseService.execParse('<<bsk:property("' + value + '")>>');
            }
        }
        return '';
    }

    public onClickAppy() {
        if (
            this.verifyRequired(
                this.action,
                this.titleNote,
                this.textNote,
                this.motiv,
                this.password,
                this.stamp,
                this.stampValue
            ) === false
        ) {
            return;
        }
        this.execAction();
    }

    public async execAction() {
        let wNbError = 0;
        let wRequest = '';
        let wRes: any;
        let updateValue;
        wRes = false;
        updateValue = this.getUpdateValue(this.action);
        wRequest = this.formatRequestTools.setActionDoc(
            this.action,
            this.currentDocId,
            this.position,
            updateValue,
            this.dimension,
            this.numPage
        );
        try {
            wRes = await lastValueFrom(this.api.execUrlAction(this.action, wRequest));
        } catch (error) {
            wNbError++;
            let lastColonPosition = error.error.Message.lastIndexOf(':');
            let message = error.error.Message.substring(lastColonPosition + 1).trim();
            this._messageService.addErrorMsg(this.translate.instant(message));
        }
        this.formatRequestTools.clear(this.currentDocId);
        wRequest = this.formatRequestTools.setUpdateThumbs();
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('updatethumbs', wRequest));
        } catch (error) {
            wNbError++;
        }
        if (wNbError === 0) {
            this._messageService.addSuccess(this.translate.instant('Work_OK'));
            this.onRefresh.emit('refresh');
            this.visible = false;
        } else {
            this._messageService.addErrorMsg(this.translate.instant('Work_KO'));
        }
    }

    public closeDia(event) {
        this.onClose.emit('close');
    }

    private getUpdateValue(aAction) {
        const type = {
            addtextpdf: this.getAddTextPdf,
            annot: this.getAnnot,
            graphsign: this.getGraphsign,
            stamp: this.getStamp,
        }
        if (type[aAction]) {
            return type[aAction](this);
        }
    }

    private getAnnot(self) {
        return {
            type: self.noteSelect,
            title: self.titleNote,
            text: self.textNote,
            color: self.colorSelect,
            open: true,
        }
    }

    private getGraphsign(self) {
        return {
            reason: self.motiv,
        }
    }

    private getStamp(self) {
        return {
            text: self.stampValue,
            size: self.stamp.Size,
            color: self.stamp.Color,
        }
    }

    private getAddTextPdf(self) {
        return {
            addtextpdf: self.textPdfValue,
            color: self.currentColor,
        }
    }

    private verifyRequired(aAction, aTitleNote, aTextNote, aMotiv, aPassword, aStamp, aStampValue) {        
        let wRes = true;
        const type = {
            annot: this.verAnnot,
            graphsign: this.verGraphsign,
            stamp: this.verStamp,
        };
        if (type[aAction]) {
            wRes = type[aAction](this._messageService, aTitleNote, aTextNote, aMotiv, aStamp, aStampValue, this.translate);
        }
        return wRes;
    }

    private verAnnot(aMessage, aTitleNote, aTextNote, aMotiv, aStamp, aStampValue, aTranslate) {
        let wRes = true;
        if (aTitleNote.trim() === '') {
            aMessage.addErrorNoStick(aTranslate.instant('Title_Req'));
            wRes = false;
        }
        if (aTextNote.trim() === '') {
            aMessage.addErrorNoStick(aTranslate.instant('Text_Req'));
            wRes = false;
        }
        return wRes;
    }

    private verGraphsign(aMessage, aTitleNote, aTextNote, aMotiv, aStamp, aStampValue, aTranslate) {
        return true;
    }

    private verStamp(aMessage, aTitleNote, aTextNote, aMotiv, aStamp, aStampValue, aTranslate) {
        let wRes = true;
        if (aStamp.Variable === 'Ask' && aStampValue.trim() === '') {
            aMessage.addErrorNoStick(aTranslate.instant('Cnt_Req'));
            wRes = false;
        }
        return wRes;
    }
}
